(() => {
  for (const configNode of document.querySelectorAll('[data-gp-custom-quote-config]')) {
    if (configNode.dataset.initialized) continue;
    configNode.dataset.initialized = 'true';
    const config = JSON.parse(configNode.textContent);
    const section = document.getElementById(`shopify-section-${config.sectionId}`);
    const root = section?.querySelector('[data-gp-custom-quote-root]');
    if (!root) continue;
    const variants = new Map(config.variants.map(v => [String(v.id), v]));
    let selectedId = String(config.selectedId);
    const update = () => {
      const variant = variants.get(selectedId);
      const quote = Boolean(variant?.quote);
      root.dataset.gpQuoteActive = String(quote);
      for (const line of root.querySelectorAll('.gp-decision > p:first-child')) {
        if (line.textContent !== config.delivery) line.textContent = config.delivery;
      }
      const message = `${config.message}\n${config.title}\n${variant?.title || ''}\n${config.url}`;
      const href = `https://wa.me/85262852233?text=${encodeURIComponent(message)}`;
      for (const price of root.querySelectorAll('.hdt-product__price')) {
        let caption = price.querySelector('.gp-custom-quote-price');
        if (!caption) { caption = document.createElement('p'); caption.className = 'gp-custom-quote-price'; price.append(caption); }
        if (caption.textContent !== config.priceLabel) caption.textContent = config.priceLabel;
        caption.hidden = !quote;
      }
      for (const buttons of root.querySelectorAll('.hdt-product-form__top-buttons, .hdt-sticky-atc__btns')) {
        let link = buttons.querySelector('.gp-custom-quote-link');
        if (!link) { link = document.createElement('a'); link.className = 'gp-custom-quote-link'; link.target = '_blank'; link.rel = 'noopener'; buttons.append(link); }
        if (link.textContent !== config.label) link.textContent = config.label;
        if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        link.hidden = !quote;
        const submit = buttons.querySelector('button[name="add"]');
        if (quote && submit && !submit.disabled) submit.disabled = true;
        if (buttons.matches('.hdt-product-form__top-buttons')) {
          let note = buttons.parentElement.querySelector('.gp-custom-quote-note');
          if (!note) { note = document.createElement('p'); note.className = 'gp-custom-quote-note'; buttons.after(note); }
          if (note.textContent !== config.note) note.textContent = config.note;
          note.hidden = !quote;
        }
      }
      for (const option of root.querySelectorAll('select[name="id"] option')) {
        if (variants.get(option.value)?.quote) {
          const label = `${variants.get(option.value).title} — ${config.priceLabel}`;
          if (option.textContent !== label) option.textContent = label;
          option.disabled = false;
        }
      }
      for (const input of root.querySelectorAll('hdt-variant-picker input[type="radio"]')) {
        const value = input.value.toLowerCase();
        if (value.includes('custom colour') || value.includes('訂製顏色')) {
          input.disabled = false;
          input.classList.remove('is-disabled');
          const label = root.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if (label) {
            label.dataset.gpQuoteOption = 'true';
            let text = label.querySelector('[data-gp-quote-option-text]');
            if (!text) { text = document.createElement('span'); text.dataset.gpQuoteOptionText = ''; label.append(text); }
            if (text.textContent !== config.priceLabel) text.textContent = config.priceLabel;
            for (const node of [...label.childNodes]) {
              if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) node.textContent = '';
            }
          }
        }
        if (quote) input.classList.remove('is-disabled');
      }
    };
    const onVariant = event => {
      const id = event.detail?.variant?.id;
      if (id && variants.has(String(id))) { selectedId = String(id); update(); }
    };
    root.addEventListener('variant:change', onVariant, true);
    root.addEventListener('submit', event => {
      const id = new FormData(event.target).get('id');
      if (variants.get(String(id))?.quote) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    const observer = new MutationObserver(update);
    observer.observe(root, { childList: true, subtree: true });
    update();
  }
})();
